import { render, staticRenderFns } from "./ExportGroup.vue?vue&type=template&id=5ca64a2f"
import script from "./ExportGroup.vue?vue&type=script&lang=js"
export * from "./ExportGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports